<template>
    <div class="detail_info">
        <div class="detail_info_content">
            <div class="detail-info__agency">
                {{ campaign.agencyName }}
            </div>
            <div class="detail-info__name">
                {{ campaign.name }}
            </div>
            <div class="detail-info__date">
                {{ getDateRange() }}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import DatetimeHelper from '@/helper/DatetimeHelper.js';

export default {
    name: 'DetailInfo',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        locale: Number,
        campaign: Object
    },
    methods: {
        getAgencyLogoUrl: function () {
            //var currentTimestamp = Math.floor(new Date() / 1000);
            return `${Vue.bzbsConfig.bzbsBlobUrl}/aia/agency/logo/${this.theme}/${this.campaign.locationAgencyId}`;
        },
        getDateRange: function () {
            var startDate = this.campaign.startDate;
            var expireDate = this.campaign.expireDate;

            if (!startDate || !expireDate) {
                return '';
            }

            return DatetimeHelper.dateRangeFormat(startDate, expireDate, this.lbl.date.month_short, this.locale, { useShortYear: true });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.detail_info {

    .detail_info_content {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .detail-info__agency {
        font-size: 16px;
        font-weight: 400;
        // font-family: $regular;
        color: $color-gray-2;
    }

    .detail-info__name {
        font-size: 20px;
        font-weight: 700;
        // font-family: $heading;
        color: $color-gray;
        @extend %ellipsis-3;
    }

    .detail-info__date {
        font-size: 16px;
        font-weight: 400;
        // font-family: $regular;
        color: $color-gray-2;
    }
}
</style>
